module.exports = __webpack_public_path__ + "static/img/zombs.dbe12f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/coach/zombs.png
// module id = GzRN
// module chunks = 35